import Script from 'next/script';
import { jsonLdScriptProps } from 'react-schemaorg';
import type { Graph, Thing, WithContext } from 'schema-dts';

export const JsonLd = <T extends Thing>({ item }: { item: WithContext<T> }) => {
  return <Script strategy="afterInteractive" {...jsonLdScriptProps<T>(item)} />;
};

export const JsonLdGraph = ({ item }: { item: Graph }) => {
  return <Script strategy="afterInteractive" {...jsonLdScriptProps(item)} />;
};
